import React, { useEffect, useState } from "react";
import "../assets/css/custom.css";
import "../assets/css/client.css";
import "../assets/css/font-awesome.css";
import "../assets/css/sweetalert.css";
import "../assets/css/bootstrap.min.css";
import "../assets/css/steps.css";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { useNavigate, Link, useLocation } from "react-router-dom";
import ReactDOM from "react-dom";
import house from "../assets/img/house.png";
import notice from "../assets/img/notice.png";
import helpIcon from "../assets/img/supportIcon.png";
import AccessKey from "../assets/img/key-person.png";
import Menus from "./menus";
import Noticemanagement from "./Noticemanagement";
import Resident from "./Resident";
import Helpdesk from "./Helpdesk";
import AccessManagement from "./AccessManagement";
import {commonAPI} from "../services/CommonAPIService"
import {ErrorSource} from '../common/constants'
import { ToastContainer, toast } from 'react-toastify';
import ServiceStaff from "./ServiceStaff/ServiceStaff";
import AddMaidModal from "./ServiceStaff/modals/addMaidModal";
import GenrateQR from "./ServiceStaff/modals/components/GenrateQR";


function Management() {
  const history = useNavigate();
  const [showMobileSubMenu, setShowMobileSubMenu] = useState(false)
  const [activeTab, setActiveTab] = useState("tab1");
  const [Accessenable, setAccessenable] = useState("");
  const location = useLocation();
    //const data = location.state
    console.log("dataParms", location)
  const handleTabChange = (tab) => {
    localStorage.setItem("lastTabManagent", tab)
    setActiveTab(tab);
  };
  const [reset, setReset] = useState(0);
  

  // useEffect(()=>{
  //   const auth = localStorage.getItem("userData");
  //   const myUserData = JSON.parse(auth);
  //   console.log(myUserData,"USERDATA")
  //   console.log(myUserData?.roleName != "Society Admin" || myUserData?.roleName != "Support Admin" || myUserData?.roleName != "Super Admin","DATATA")
  //   if(myUserData?.roleName != "Society Admin" || myUserData?.roleName != "Support Admin" || myUserData?.roleName != "Super Admin"){
  //     history('/Dashboard');
  //     // alert("Hello")
  //   }
    
  // },[])

  const storedUsername = localStorage.getItem('userData');
  const myUserData = JSON.parse(storedUsername);

  useEffect(() => {
    localStorage.setItem("lastTab", "tab1")
    localStorage.setItem("lastTabApproval", "tab1")
    localStorage.setItem("lastTabUtility", "tab1")
    const lastTab = localStorage.getItem("lastTabManagent");
    if (!lastTab) {
      if(myUserData?.roleName == "Society HelpDesk"){
        setActiveTab("tab3")  
      }else{
        setActiveTab("tab1")
      }
    }
    else {
      setActiveTab(lastTab)
    }

  }, [])

  useEffect(() => {
    const storedUsername = localStorage.getItem('userData');
    const myUserData = JSON.parse(storedUsername);
    console.log("useEffect Local storage name", storedUsername)
    console.log("Role Name", myUserData?.roleName != "Society Admin" || myUserData?.roleName != "Support Admin" || myUserData?.roleName != "Super Admin")
    if (storedUsername) {
      // If the username is present, redirect to the dashboard
      if(myUserData?.roleName == "Society Admin" || myUserData?.roleName == "Support Admin" || myUserData?.roleName == "Super Admin" || myUserData?.roleName == "Society Operator" || myUserData?.roleName == "Society HelpDesk" ){
        if(myUserData?.roleName == "Society Admin" || myUserData?.roleName == "Super Admin" || myUserData?.roleName == "Society Operator" || myUserData?.roleName == "Society HelpDesk"){
          history('/Management');
          return
        }else{
          history('/Dashboard');
        }  
      }else{
        history('/Dashboard');
        console.log("useEffect Local storage Yes")
        return
      }  
    }
    else if (storedUsername === null) {
      history('/');
      console.log("useEffect Local storage No")
    }
  }, [history]);

  const GetApplicationList = async () => {
      try {
        const storedUsername = localStorage.getItem('userData');
        const myUserData = JSON.parse(storedUsername);
           const endPointVariableKey = {
                urlVariable: null,
                buildingId: myUserData?.buildingId
            }
            let response = await commonAPI("AppSettings", undefined, endPointVariableKey);
            console.log("AppSettings", response);
            if (response?.success === true) {
              console.log("Table AppSettings", response.data)
              const accessControlModuleEnable = response?.data.find(item => item.key === 'ACCESS_CONTROL_MODULE_ENABLE')?.value;
              setAccessenable(accessControlModuleEnable);
              console.log("accessControlModuleEnable", accessControlModuleEnable)
            } else {
              toast.error("Something went wrong");
            }
  
      } catch (error) {
          console.log(error);
          const auth = localStorage.getItem("userData");
              const myUserData = JSON.parse(auth);
              const bodyError = { 
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": null,
                "uri": "/api/Master/Building",
                "errorNumber": "GB01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "tower.js",
                "functionName": "GetBuildingList",
          };
          let response = await commonAPI("ErrorLogMaster", bodyError);
          console.log("statusCode", response);
          toast.error("Something went wrong");
      }
  
    }

    useEffect(() => {
      GetApplicationList(); 
    }, [])

  return (
    <>
      <Menus />
      <section className="tabular_intergration">
        <div className="tab-container">
          <div className="UnderBox-Shadow">
            <div className="container-fluid py-0 px-0 hideContainer">
              <div className="row">
                <div className="col-lg-12 col-dm-12 col-sm-12 col-12">
                  <div className="tabs d-flex">
                  {myUserData?.roleName == "Society Admin" || myUserData?.roleName == "Super Admin" || myUserData?.roleName == "Society Operator" ?
                    <>
                      <button
                        className={activeTab === "tab1" ? "active-tab" : "subfeildbtn d-flex align-items-center"}
                        onClick={() => handleTabChange("tab1")}
                      >
                        <img src={house} className="img" style={{ width: "21px",marginRight:"5px" }} />{""}
                        Resident Management
                      </button>
                      <button
                        className={activeTab === "tab2" ? "active-tab" : "subfeildbtn d-flex align-items-center"}
                        onClick={() => handleTabChange("tab2")}
                      >
                        <img src={notice} className="img" style={{ width: "21px",marginRight:"5px" }} />{""}
                        Notice Management
                        
                      </button>
                      {Accessenable == 1 ?
                        <button
                          className={activeTab === "tab4" ? "active-tab" : "subfeildbtn"}
                          onClick={() => handleTabChange("tab4")}
                        >
                          <img src={AccessKey} className="img" style={{ width: "21px" }} />{" "}
                          Access Management
                          
                        </button>
                      :null}
                    </>
                    :null}  
                      
                    {myUserData?.roleName == "Society HelpDesk" || myUserData?.roleName == "Society Admin" || myUserData?.roleName == "Super Admin" || myUserData?.roleName == "Society Operator" ?
                      <>
                      <button
                        className={activeTab === "tab3" ? "active-tab" : "subfeildbtn d-flex align-items-center"}
                        onClick={() => handleTabChange("tab3")}
                      >
                        <img src={helpIcon} className="img" style={{ width: "21px",marginRight:"5px" }} />{""}
                        Help Desk
                        
                      </button>
                    </>  
                    :null}  
                    <button
                      className={activeTab === "tab5" ? "active-tab" : "subfeildbtn"}
                      onClick={() => handleTabChange("tab5")}
                    >
                      <img src={AccessKey} className="img" style={{ width: "21px" }} />{" "}
                      Service Staff
                      
                    </button>
                     {/* <button
                        className={activeTab === "tab6" ? "active-tab" : "subfeildbtn d-flex align-items-center"}
                        onClick={() => handleTabChange("tab6")}
                      >
                        <img src={helpIcon} className="img" style={{ width: "21px",marginRight:"5px" }} />{""}
                        add maid
                        
                      </button> */}
                     
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="mobileViewSubMenu" style={{width:"100%"}}>
        <div className="rebon" onClick={() => { setShowMobileSubMenu(!showMobileSubMenu) }}>
          {showMobileSubMenu === false && <FaChevronDown className="rebonChevron" size="12px" />}
          {showMobileSubMenu === true && <FaChevronUp className="rebonChevron" size="12px" />}
        </div>
        <div className={`submenu ${showMobileSubMenu ? "open" : "closed"}`}>
          <div className="row">
            <div className="col-lg-12 col-dm-12 col-sm-12 col-12">
              <div className="tabs">
              {myUserData?.roleName == "Society Admin" || myUserData?.roleName == "Super Admin" || myUserData?.roleName == "Society Operator" ?
                <>
                  <button
                    className={activeTab === "tab1" ? "active-tab" : "subfeildbtn"}
                    onClick={() => handleTabChange("tab1")}
                  >
                    <img src={house} className="img" style={{ width: "21px" }} />{""}
                    Resident Management
                  </button>
                  <button
                    className={activeTab === "tab2" ? "active-tab" : "subfeildbtn"}
                    onClick={() => handleTabChange("tab2")}
                  >
                    <img src={notice} className="img" style={{ width: "21px" }} />{" "}
                    Notice Management
                    
                  </button>
                  {Accessenable == 1 ?
                    <button
                      className={activeTab === "tab4" ? "active-tab" : "subfeildbtn"}
                      onClick={() => handleTabChange("tab4")}
                    >
                      <img src={AccessKey} className="img" style={{ width: "21px" }} />{" "}
                      Access Management
                      
                    </button>
                  :null}
                </>
                :null}  
                {myUserData?.roleName == "Society HelpDesk" || myUserData?.roleName == "Society Admin" || myUserData?.roleName == "Super Admin" || myUserData?.roleName == "Society Operator" ?
                  <>
                    <button
                      className={activeTab === "tab3" ? "active-tab" : "subfeildbtn d-flex align-items-center"}
                      onClick={() => handleTabChange("tab3")}
                    >
                      <img src={helpIcon} className="img" style={{ width: "21px",marginRight:"5px" }} />{""}
                      Help Desk
                      
                    </button>
                  </>
                  :null}  
                  <button
                      className={activeTab === "tab5" ? "active-tab" : "subfeildbtn d-flex align-items-center"}
                      onClick={() => handleTabChange("tab5")}
                    >
                      <img src={helpIcon} className="img" style={{ width: "21px",marginRight:"5px" }} />{""}
                      Service Staff
                      
                    </button>
                      {/* <button
                      className={activeTab === "tab6" ? "active-tab" : "subfeildbtn d-flex align-items-center"}
                      onClick={() => handleTabChange("tab6")}
                    >
                      <img src={helpIcon} className="img" style={{ width: "21px",marginRight:"5px" }} />{""}
                      add maid
                      
                    </button> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="OneClr_apply">
        <div className="container-fluid">
          <div className='row'>
            <div className="col-12 ">


              {activeTab === "tab1" && (
                <div>
                  <Resident />
                </div>
              )}
              {activeTab === "tab2" && (
                <div>
                  <Noticemanagement />
                </div>
              )}
              {activeTab === "tab3" && (
                <div>
                  <Helpdesk />
                </div>
              )}
              {activeTab === "tab4" && (
                <div>
                  <AccessManagement />
                </div>
              )}
              {activeTab === "tab5" && (
                <div>
                  <ServiceStaff />
                </div>
              )}
              {/* {activeTab === "tab2" && (
                <div>
                  <NoticeApproval />
                </div>
              )}
   */}
      {activeTab === "tab6" && (
                <div>
                  <GenrateQR />
                </div>
              )}

            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Management;
